'use strict';

var gridDocsCtrl = ['$state', '$uibModal', '$http', 'toast', function ($state, $uibModal, $http, toast) {
    var _this = this;
    _this.getDocs = function () {
        var docsNode = (_this.data && _this.data.payload) ? _this.data.payload[_this.field] : { value: _this.data ? _this.data[_this.field] : null, type: 'docs' };
        var docs = docsNode && docsNode.value;
        return Array.isArray(docs) ? docs : [];
    };

    _this.getDocsCount = function () {
        return _this.getDocs().length;
    };

    _this.hasDocs = function () {
        return _this.getDocsCount() > 0;
    };

    _this.viewDocs = function () {
        if (!_this.hasDocs()) {
            return;
        }

        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'directives/gridDocsDirective.html',
            controller: ['docs', '$http', '$timeout', '$q', function (docs, $http, $timeout, $q) {
                var _this = this;
                this.docs = docs.value;
                this.downloading = false;
                this.downloadProgress = 0;

                this.downloadFile = function (doc) {
                    let deferred = $q.defer();

                    $http({
                        method: 'GET',
                        url: doc.uri,
                        responseType: 'blob'
                    }).then(function (response) {
                        let blob = new Blob([response.data], { type: response.headers('Content-Type') });
                        let link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = doc.name;
                        link.click();
                        window.URL.revokeObjectURL(link.href);
                        deferred.resolve();
                    }).catch(function (error) {
                        console.error('Error descargando el archivo:', error);
                        toast.error($translate.instant('No se pudo descargar el archivo: ') + doc.name);
                        deferred.reject(error);
                    });

                    return deferred.promise;
                };

                this.downloadAll = function () {
                    _this.downloading = true;
                    _this.downloadProgress = 0;

                    let downloadNext = function (index) {
                        if (index >= _this.docs.length) {
                            _this.downloading = false;
                            _this.downloadProgress = 0;
                            toast.error($translate.instant('Archivo ') + index + ' ' + $translate.instant('descargado correctamente!'));
                            return;
                        }

                        _this.downloadProgress = index + 1;

                        _this.downloadFile(_this.docs[index]).then(
                            function () {
                                $timeout(function () {
                                    downloadNext(index + 1);
                                }, 0);
                            },
                            function () {
                                if (confirm('Hubo un error. ¿Deseas continuar con el siguiente archivo?')) {
                                    $timeout(function () {
                                        downloadNext(index + 1);
                                    }, 500);
                                } else {
                                    _this.downloading = false;
                                    _this.downloadProgress = 0;
                                }
                            }
                        );
                    };

                    downloadNext(0);
                };
            }],
            controllerAs: 'modal',
            size: 'md',
            resolve: {
                docs: function () {
                    return (_this.data.payload ? _this.data.payload[_this.field] : { value: _this.data[_this.field], type: 'docs' })
                }
            },
            windowClass: 'dialog',
            bindToController: true
        });

        modalInstance.result.then(function (selectedItem) {
            _this.selected = selectedItem;
        }, function () {

        });
    };

}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            field: '=',
            data: '='
        },
        controller: gridDocsCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        template: '<span ng-if="!ctrl.hasDocs()">Sin Docs</span><a ng-if="ctrl.hasDocs()" ng-click="ctrl.viewDocs(); $event.stopPropagation()">Ver Docs ({{ctrl.getDocsCount()}})</a>'
    };
};
